<template>
  <div>
    <h1 class="mt-8 mb-2 font-medium text-left text-gray-900">
      {{ $t("device.form.msisdn") }} <span class="text-sm text-gray-600"> </span>
    </h1>

    <div class="mt-1 mb-2">
      <input type="text" disabled="true" :value=device.msisdn class="w-full text-gray-500 border border-gray-300 rounded-lg disabled:opacity-80 sm:text-sm border-unset" :placeholder='$t("device.form.nomsisdn")' />
    </div>
  </div>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";

export default {
  name: "PhoneNumberDisplay",
  components: {

  },

  props: [],
  emits: [],

  setup() {
    const store = useStore();
    const device = computed(() => store.state.device.current);

    return {
      device
    };
  },
};
</script>
